import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Location } from '../../model/Location';
import { FileDto, FolderDto } from '@braoshzmvavz/picnube-common';
import { setServers } from 'dns';

interface SearchState {
    simpleSearch: string | null;
    locations: Location[];
    folders: FolderDto[];
    files: FileDto[];
    filesPage: number;
    loading: boolean;
    error: string | null;
    isFirstSearch: boolean;
}

const initialState: SearchState = {
    simpleSearch: null,
    locations: [],
    folders: [],
    files: [],
    filesPage: 0,
    loading: false,
    error: null,
    isFirstSearch: true,
};

export const searchSlice = createSlice({
    name: 'search',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        resetSearchToInitialState: state => {
            state.simpleSearch = null
            state.locations = []
            state.folders = []
            state.files = []
            state.filesPage = 0
            state.loading = false
            state.error = null
            state.isFirstSearch = true
        },

        setFolders: (state, action: PayloadAction<FolderDto[]>) => {
            state.folders = [...action.payload]
        },

        setFiles: (state, action: PayloadAction<FileDto[]>) => {
            state.files = [...action.payload]
        },

        setLocations: (state, action: PayloadAction<Location[]>) => {
            state.locations = [...action.payload]
        },

        setSimpleSearch: (state, action: PayloadAction<string | null>) => {
            state.simpleSearch = action.payload
        },

        setIsFirstSearch: (state, action: PayloadAction<boolean>) => {
            state.isFirstSearch = action.payload
        },

        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        }
    }
})

export const {
    resetSearchToInitialState,
    setLocations,
    setFiles,
    setIsFirstSearch,
    setFolders,
    setSimpleSearch,
    setLoading,
} = searchSlice.actions

export default searchSlice.reducer